export class Student {
  user_id: number
  login_id: string
  student_num: number
  name: string
  nendo: number
  grade: number
  room_id: number
  room_name: string
  number: number

  constructor(student: any){
    this.user_id = student.user_id;
    this.login_id = student.login_id;
    this.student_num = student.student_num;
    this.name = student.name;
    this.nendo = student.nendo;
    this.grade = student.grade_id;
    this.room_id = student.room_id;
    this.room_name = student.room_name;
    this.number = student.number;
  }
}

export class SheetResult {
  sheet_group_key: number
  sheet_name: string
  rating_info: any
  goal_rating_info: any
  avg_info: any
  rank_info: any

  constructor(sheet_result: any){
    this.sheet_group_key = sheet_result.sheet_group_key;
    this.sheet_name = sheet_result.sheet_name;
    this.rating_info = sheet_result.rating_info;
    this.goal_rating_info = sheet_result.goal_rating_info;
    this.avg_info = sheet_result.avg_info;
    this.rank_info = sheet_result.rank_info;
  }
}

export class Curriculum {
  id: number
  name: string
  subjects: Subject[]

  constructor(curriculum: any){
    this.id = curriculum.id;
    this.name = curriculum.name;
    this.subjects = curriculum.subjects.map((x: any) => new Subject(x));
  }
}

export class Subject {
  id: number
  name: string
  subject_num: string

  constructor(subject: any){
    this.id = subject.id;
    this.name = subject.name;
    this.subject_num = subject.subject_num;
  }
}